import { Col, Row, Form, ConfigProvider } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";

import Selects from "../../../../biblio/Selects/Selects";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import { OrphanModel } from "../models/Orphan";
import ar_EG from "antd/lib/locale/ar_EG";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ar";
import HijriFeature from "../../../../biblio/HijriFeature";
dayjs.extend(updateLocale);

dayjs.updateLocale("ar", {
  weekStart: 6,
  weekdays: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
});

interface ChildrenProps {
  nationality: any;
  identificationTypes: any;
  maritalStatus: any;
  index: number;
  form: any;
  parentForm: any;
  onChange: (value: any, key: keyof OrphanModel, index: number) => void;
  handleFileChange: (fileList: any[]) => void;
  defaultFile: any[];
  item: any;
}

const OrphanForm = ({
  nationality,
  maritalStatus,
  identificationTypes,
  index,
  form,
  parentForm,
  onChange,
  handleFileChange,
  defaultFile,
  item,
}: ChildrenProps) => {
  /** find nationality by id */
  const findNationality =
    nationality &&
    nationality?.data?.find(
      (item: any) =>
        item.id === form.getFieldValue(`nationality_id${index}`)?.value
    );

  return (
    <ConfigProvider locale={ar_EG} direction="rtl">
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`firstname${index}`}
            label="الاسم الأول"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) => onChange(e.target.value, "firstname", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`father_name${index}`}
            label="إسم الأب"
            initialValue={parentForm.getFieldValue(`father_firstname`)}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) => onChange(e.target.value, "father_name", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`grandfather_name${index}`}
            label="إسم الجد"
            initialValue={parentForm.getFieldValue(`father_father_name`)}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) =>
                onChange(e.target.value, "grandfather_name", index)
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`family_name${index}`}
            label="إسم العائلة"
            initialValue={parentForm.getFieldValue(`father_family_name`)}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) => onChange(e.target.value, "family_name", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`eng_name${index}`}
            label="الاسم بالانجليزية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) => onChange(e.target.value, "eng_name", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`gender${index}`}
            label="الجنس"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={[
                { id: 1, name: "ذكر" },
                { id: 2, name: "أنثى" },
              ]}
              onChange={(e) => onChange(e, "gender", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`birthday${index}`}
            label="تاريخ الميلاد"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
            validateTrigger="onBlur"
          >
            <HijriFeature
              value={item.birthday}
              onChange={(dateValue) => onChange(dateValue, "birthday", index)}
              maxDateGregorian={dayjs(new Date())}
              maxDateHijri={dayjs(new Date()).toDate()}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`nationality_id${index}`}
            label="الجنسية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={nationality?.data}
              onChange={(e) => onChange(e, "nationality_id", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`marital_status_id${index}`}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            label="الحالة الإجتماعية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={maritalStatus.data}
              onChange={(e) => onChange(e, "marital_status_id", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`email${index}`}
            label="البريد الإلكتروني"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                type: "email",
                message: "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
              },
            ]}
          >
            <Inputs
              placeholder="email@example.com"
              type="email"
              onChange={(e) => onChange(e.target.value, "email", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`phone${index}`}
            label="الهاتف الأول"
            rules={[
              {
                len: 10,
                message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              placeholder="05XXXXXXXX"
              type="tel"
              onChange={(e) => onChange(e.target.value, "phone", index)}
              maxLength={10}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`mobile${index}`}
            label="الهاتف الثاني"
            rules={[
              {
                len: 10,
                message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              placeholder="05XXXXXXXX"
              type="tel"
              onChange={(e) => onChange(e.target.value, "mobile", index)}
              maxLength={10}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identification_type_id${index}`}
            label="نوع الهوية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={identificationTypes.data}
              onChange={(e) => onChange(e, "identification_type_id", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identification_number${index}`}
            label="رقم الهوية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
              {
                len: 10,
                message: "يجب أن يتكون رقم الهوية من 10 ارقام",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="tel"
              onChange={(e) =>
                onChange(e.target.value, "identification_number", index)
              }
              maxLength={10}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identification_source${index}`}
            label="مصدر الهوية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="text"
              onChange={(e) =>
                onChange(e.target.value, "identification_source", index)
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identification_date${index}`}
            label="تاريخ الهوية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <HijriFeature
              value={item.identification_date}
              onChange={(e) => onChange(e, "identification_date", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identification_deadline${index}`}
            rules={[
              {
                required: findNationality?.code !== "SA",
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            label="تاريخ نهاية الهوية"
            labelCol={{ className: "takaful--label-style" }}
            validateTrigger="onBlur"
          >
            <HijriFeature
              value={item.identification_deadline}
              onChange={(e) => onChange(e, "identification_deadline", index)}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`identify_image_ids${index}`}
            label="صورة هوية/اقامة"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="image/*"
              text="صورة هوية/اقامة"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={handleFileChange}
              list={defaultFile}
            />
          </Form.Item>
        </Col>
      </Row>
    </ConfigProvider>
  );
};

export default OrphanForm;
